import type { RouteRecordRaw, Router } from 'vue-router'

const RecipientContractRoutes: RouteRecordRaw = {
  path: '/contract/nonFinancial/recipient',
  name: 'RecipientModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'RecipientMainRoute',
      component: () => import('./views/SupportView.vue'),
      meta: {
        title: 'recipient.recipientContract',
      },
    },
    {
      path: 'create',
      name: 'RecipientCreateRoute',
      component: () => import('./views/SupportUpsertView.vue'),
      meta: {
        title: 'recipient.createRecipientContract',
      },
    },
    {
      path: 'edit/:supportId',
      name: 'RecipientEditRoute',
      component: () => import('./views/SupportUpsertView.vue'),
      meta: {
        title: 'recipient.editRecipientContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:supportId',
      name: 'ViewRecipientRoute',
      component: () => import('./views/SingleSupportView.vue'),
      meta: {
        title: 'recipient.ViewRecipient',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(RecipientContractRoutes)
}
